import React from 'react'
import Select from 'react-select'
import { DAY_DISPLAY_FORMAT } from '../../../constants/timeFormats'
import moment from 'moment'

export const sortArr = (arr = []) => {
  const allOptionIndex = arr.findIndex(a => a.label === 'All')
  let allOption = null
  if (allOptionIndex !== -1) {
    allOption = arr[allOptionIndex]
    arr.splice(allOptionIndex, 1)
  }
  const newArray = arr.sort((a, b) =>
    moment(a.value, DAY_DISPLAY_FORMAT).valueOf() > moment(b.value, DAY_DISPLAY_FORMAT).valueOf()
      ? 1
      : -1,
  )
  if (allOption) {
    newArray.unshift(allOption)
  }
  return newArray
}

const sortHours = (arr = []) => arr.sort((a, b) => (a.label > b.label ? 1 : -1))

const SelectTimeSlotItem = props => {
  const onChangeDay = e => {
    if (props.day.value !== e.value) {
      props.onChangeDay(e, props.day)
    }
  }
  const onChangeTime = e => {
    props.onChangeTime(e || [], props.day)
  }
  const onDelete = () => {
    props.onDelete(props.day)
  }
  const { day, noSelectedDays } = props
  const dayOptions = sortArr([...noSelectedDays])
  const hourOptions = sortHours(day.options)
  const isAllOptionSelected = day.value === 'All'
  const allTicketsSelected = isAllOptionSelected ? true : props.day.options.length === props.day.selectedTickets.length

  return (
    <div>
      <div style={{ display: 'inline-block', float: 'left', width: 300, margin: '5px 10px 5px 20px' }}>
        <Select onChange={onChangeDay} value={day} options={dayOptions} />
      </div>
      {!isAllOptionSelected && (
        <div style={{ display: 'inline-block', float: 'left', width: 300, margin: '5px 0' }}>
          <Select
            multi
            value={allTicketsSelected ? [] : props.day.selectedTickets}
            placeholder="All Time Slots"
            onChange={onChangeTime}
            options={hourOptions}
          />
        </div>
      )}
      {!isAllOptionSelected && (
        <div
          style={{ display: 'inline-block', float: 'left', padding: '12px 0 0 10px', cursor: 'pointer' }}
        >
          <i aria-hidden onClick={onDelete} style={{ fontSize: '22px' }} className="fa fa-trash" />
        </div>
      )}
    </div>
  )
}

export default SelectTimeSlotItem